const KEY = "lssd_post_login_redirect";
const MAX_AGE_MS = 30 * 60 * 1000;

export function savePostLoginRedirect(path) {
  if (!path || !path.startsWith("/dashboard")) return;
  try { sessionStorage.setItem(KEY, JSON.stringify({ path, ts: Date.now() })); } catch (err) { console.debug("[redirect] save failed", err); }
}

export function consumePostLoginRedirect(fallback = "/dashboard") {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return fallback;
    const { path, ts } = JSON.parse(raw);
    if (typeof path === "string" && path.startsWith("/dashboard") && Date.now() - ts < MAX_AGE_MS) return path;
  } catch (err) { console.debug("[redirect] consume failed", err); }
  return fallback;
}
